import type MapScale from '@/Enums/Map/MapScale.enum';

// GAM-specific report views. Region is omitted (state-level data flows
// through the MapSection State scale instead).
enum GamReportView {
  Date = 'Date',
  Channel = 'Channel',
  Device = 'Device',
  Advertiser = 'Advertiser',
  Campaign = 'Campaign',
  Placement = 'Placement',
  Creative = 'Creative',
  Publisher = 'Publisher',
  DayOfWeek = 'Days of Week',
  Daypart = 'Daypart',
  Deals = 'Deals',
  GeoFence = 'Geo-Fence',
}

// The grid switcher carries both flat report views AND the geo scales
// (rendered as a "Geo" submenu) — same shape as Simplifi's union.
export type GamGridView = GamReportView | MapScale;

export default GamReportView;
